
export interface Agent {
  id: number;
  nom: string;
  prenom: string;
  email: string;
  telephone: string;
}
export enum NetworkStatus {
    OFFLINE = 'OFFLINE',
    ONLINE = 'ONLINE',
    UNKNOWN = 'UNKNOWN'
}
export interface LoginRequest {
    username: string;
    password: string;
}
export interface LoginResponse {
    token: string;
    agent: Agent;
}